/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';

export const ChatIcon = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g>
				{/* the star */}
				<path
					d="M10.4489 3.4504L7.75593 4.49767C7.75381 4.4985 7.75381 4.5015 7.75593 4.50233L10.4489 5.5496C10.4496 5.54986 10.4501 5.55037 10.4503 5.55103L11.4976 8.24401C11.4984 8.24613 11.5014 8.24613 11.5023 8.24401L12.5495 5.55103C12.5498 5.55037 12.5503 5.54986 12.551 5.5496L15.2439 4.50233C15.2461 4.5015 15.2461 4.4985 15.2439 4.49767L12.551 3.4504C12.5503 3.45014 12.5498 3.44963 12.5495 3.44897L11.5023 0.755991C11.5014 0.753866 11.4984 0.753866 11.4976 0.755991L10.4503 3.44897C10.4501 3.44963 10.4496 3.45014 10.4489 3.4504Z"
					stroke="currentColor"
					strokeWidth="1.5"
				/>
				{/* the chat icon */}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M0 3.125C0 1.67525 1.17525 0.5 2.625 0.5H7.5V2H2.625C2.00368 2 1.5 2.50368 1.5 3.125V13.9576L4.05083 12.5H13.375C13.9963 12.5 14.5 11.9963 14.5 11.375V9H16V11.375C16 12.8247 14.8247 14 13.375 14H4.44917L1.12584 15.899C0.624381 16.1856 0 15.8237 0 15.2457V3.125Z"
					fill="currentColor"
				/>
			</g>
		</svg>
	);
};
